import Skeleton from "@components/global/new/Skeleton/Skeleton";
import styles from "./SkeletonMiner.module.scss";
import cn from "classnames";

export default function SkeletonMiner() {
  // const me = useMe();
  return (
    <div className={cn(styles.wrapper)}>
      {Array.from(new Array(5)).map((item, i) => (
        <Skeleton key={i} className={styles.item} />
      ))}
    </div>
  );
}
